// extracted by mini-css-extract-plugin
export default {"questions-container":"Questions_questions-container__gXrsj"};